import { ResearchNew } from "../../../api/research.types";
import { ResearchesNewAction } from "./researches.new.types";

export const researchesNewRequestAction = (): ResearchesNewAction => ({ type: 'RESEARCHES_NEW_REQUEST' })
export const researchesNewSuccessAction = (researches: ResearchNew[]): ResearchesNewAction => ({ type: 'RESEARCHES_NEW_SUCCESS', params: researches })
export const researchesNewFailureAction = (error?: any): ResearchesNewAction => ({ type: 'RESEARCHES_NEW_FAILURE', params: error })